// City-specific data for programmatic SEO landing pages
// Each city renders at /:slug (e.g. /bail-lawyer-delhi)

export const CITIES = {
  "bail-lawyer-delhi": {
    slug: "bail-lawyer-delhi",
    city: "Delhi",
    cityHindi: "दिल्ली",
    highCourt: "Delhi High Court",
    highCourtHindi: "दिल्ली उच्च न्यायालय",
    established: "1966",
    seat: "Sher Shah Road, New Delhi",
    jurisdiction: "National Capital Territory of Delhi",
    metaTitle: "Bail Lawyer in Delhi — Verified by Delhi High Court Outcomes",
    metaTitleHindi: "दिल्ली में ज़मानत वकील — दिल्ली उच्च न्यायालय के असली नतीजों पर आधारित",
    metaDescription:
      "Find verified bail lawyers in Delhi ranked by real Delhi High Court success rates. Regular, anticipatory, and interim bail — for Tis Hazari, Patiala House, Saket, Rohini, Karkardooma courts. No munshis. No dallaals.",
    metaDescriptionHindi:
      "दिल्ली में सत्यापित ज़मानत वकील खोजें — असली दिल्ली उच्च न्यायालय की सफलता दर पर आधारित। तीस हज़ारी, पटियाला हाउस, साकेत, रोहिणी, कड़कड़डूमा कोर्ट के लिए।",
    heroH1: "A verified bail lawyer in Delhi — before the sun sets.",
    heroH1Hindi: "दिल्ली में एक सत्यापित ज़मानत वकील — सूरज ढलने से पहले।",
    heroSub:
      "Rihai connects Delhi families with lawyers whose High Court bail win-rate we can actually show you — vetted across Tis Hazari, Patiala House, Saket, Rohini and Karkardooma courts.",
    heroSubHindi:
      "Rihai दिल्ली के परिवारों को ऐसे वकीलों से जोड़ता है जिनकी हाई कोर्ट में ज़मानत जीत की दर हम आपको दिखा सकते हैं — तीस हज़ारी, पटियाला हाउस, साकेत, रोहिणी और कड़कड़डूमा में जांचे गए।",
    subordinateCourts: [
      "Tis Hazari District Court",
      "Patiala House Court",
      "Saket District Court",
      "Rohini District Court",
      "Karkardooma District Court",
      "Dwarka District Court",
    ],
    landmarks: ["Sher Shah Road", "ITO", "Connaught Place", "India Gate"],
    localFAQ: [
      {
        q: "How fast can I get bail in Delhi?",
        a: "For cognizable offences moved through Tis Hazari or Patiala House, urgent bail applications can be listed the same day or the next working day. Anticipatory bail typically takes 3–7 days depending on the bench.",
        qHi: "दिल्ली में ज़मानत कितनी जल्दी मिल सकती है?",
        aHi: "तीस हज़ारी या पटियाला हाउस में तात्कालिक ज़मानत आवेदन उसी दिन या अगले कार्य दिवस में सूचीबद्ध हो सकते हैं। अग्रिम ज़मानत में आमतौर पर 3–7 दिन लगते हैं।",
      },
      {
        q: "Which court does my case go to?",
        a: "Court assignment in Delhi depends on the police station area — Tis Hazari for North Delhi, Patiala House for New Delhi, Saket for South Delhi, Rohini for outer North-West, Karkardooma for East Delhi, Dwarka for South-West.",
        qHi: "मेरा केस कौन सी कोर्ट में जाएगा?",
        aHi: "दिल्ली में कोर्ट का असाइनमेंट पुलिस स्टेशन क्षेत्र पर निर्भर करता है — उत्तरी दिल्ली के लिए तीस हज़ारी, नई दिल्ली के लिए पटियाला हाउस, दक्षिणी दिल्ली के लिए साकेत।",
      },
    ],
  },

  "bail-lawyer-allahabad": {
    slug: "bail-lawyer-allahabad",
    city: "Prayagraj (Allahabad)",
    cityHindi: "प्रयागराज (इलाहाबाद)",
    highCourt: "Allahabad High Court",
    highCourtHindi: "इलाहाबाद उच्च न्यायालय",
    established: "1866",
    seat: "Prayagraj, Uttar Pradesh",
    jurisdiction: "State of Uttar Pradesh",
    metaTitle: "Bail Lawyer in Allahabad (Prayagraj) — Allahabad High Court Verified",
    metaTitleHindi: "प्रयागराज में ज़मानत वकील — इलाहाबाद उच्च न्यायालय के नतीजों पर आधारित",
    metaDescription:
      "Verified bail advocates for the Allahabad High Court and Prayagraj district courts. Ranked by real judgment outcomes. Fast turnaround for CJM and Sessions Court matters across UP.",
    metaDescriptionHindi:
      "इलाहाबाद उच्च न्यायालय और प्रयागराज ज़िला अदालतों के लिए सत्यापित ज़मानत वकील। असली नतीजों पर आधारित रैंकिंग।",
    heroH1: "A verified bail advocate at the Allahabad High Court — without the middlemen.",
    heroH1Hindi: "इलाहाबाद उच्च न्यायालय में एक सत्यापित ज़मानत वकील — बिना बिचौलियों के।",
    heroSub:
      "One of India's largest and oldest High Courts. Rihai matches you with advocates whose track record we can prove — for Prayagraj, Kaushambi, Pratapgarh and wider UP jurisdiction.",
    heroSubHindi:
      "भारत के सबसे बड़े और पुराने उच्च न्यायालयों में से एक। Rihai आपको ऐसे वकीलों से जोड़ता है जिनका रिकॉर्ड हम साबित कर सकते हैं।",
    subordinateCourts: [
      "Prayagraj District & Sessions Court",
      "Chief Judicial Magistrate, Prayagraj",
      "Kaushambi District Court",
      "Pratapgarh District Court",
      "Fatehpur District Court",
    ],
    landmarks: ["Sangam", "Prayagraj High Court campus", "Civil Lines"],
    localFAQ: [
      {
        q: "Is the Allahabad HC the same as the Lucknow Bench?",
        a: "The Allahabad High Court has its principal seat at Prayagraj and a bench at Lucknow. Cases from western UP and some central UP districts are heard at Prayagraj; eastern UP cases are heard at the Lucknow bench.",
        qHi: "क्या इलाहाबाद HC और लखनऊ बेंच एक ही हैं?",
        aHi: "इलाहाबाद उच्च न्यायालय का मुख्य पीठ प्रयागराज में है और एक बेंच लखनऊ में। पश्चिमी और मध्य UP के मामले प्रयागराज में सुने जाते हैं; पूर्वी UP के मामले लखनऊ बेंच में।",
      },
      {
        q: "How long does bail take at Allahabad HC?",
        a: "Urgent bail matters can be mentioned and listed within 1–3 working days. Regular bail applications typically move within a week if properly filed.",
        qHi: "इलाहाबाद HC में ज़मानत में कितना समय लगता है?",
        aHi: "तात्कालिक मामले 1–3 कार्य दिवसों में सूचीबद्ध हो सकते हैं। नियमित ज़मानत आवेदन आमतौर पर एक सप्ताह में गति पकड़ते हैं।",
      },
    ],
  },

  "bail-lawyer-lucknow": {
    slug: "bail-lawyer-lucknow",
    city: "Lucknow",
    cityHindi: "लखनऊ",
    highCourt: "Allahabad High Court — Lucknow Bench",
    highCourtHindi: "इलाहाबाद उच्च न्यायालय — लखनऊ बेंच",
    established: "1948 (bench)",
    seat: "Lucknow, Uttar Pradesh",
    jurisdiction: "Awadh region and eastern UP districts",
    metaTitle: "Bail Lawyer in Lucknow — Allahabad HC Lucknow Bench Verified",
    metaTitleHindi: "लखनऊ में ज़मानत वकील — इलाहाबाद उच्च न्यायालय लखनऊ बेंच से सत्यापित",
    metaDescription:
      "Find verified bail lawyers in Lucknow ranked by real Lucknow Bench outcomes. Cover for Sessions Court, CJM Lucknow, and eastern UP districts. Anticipatory and regular bail — moved quickly.",
    metaDescriptionHindi:
      "लखनऊ में सत्यापित ज़मानत वकील — असली लखनऊ बेंच के नतीजों पर आधारित। सत्र न्यायालय, CJM लखनऊ, और पूर्वी UP ज़िलों के लिए।",
    heroH1: "A verified bail lawyer for the Lucknow Bench — moved without a middleman.",
    heroH1Hindi: "लखनऊ बेंच के लिए एक सत्यापित ज़मानत वकील — बिना दलाल के।",
    heroSub:
      "The Lucknow Bench of the Allahabad High Court handles cases from Awadh and eastern UP. We pair you with advocates whose recent Lucknow-bench outcomes are documented.",
    heroSubHindi:
      "इलाहाबाद उच्च न्यायालय की लखनऊ बेंच अवध और पूर्वी UP के मामले सुनती है। हम आपको ऐसे वकीलों से जोड़ते हैं जिनके हाल के लखनऊ बेंच के नतीजे प्रमाणित हैं।",
    subordinateCourts: [
      "Lucknow District & Sessions Court",
      "Chief Judicial Magistrate, Lucknow",
      "Barabanki District Court",
      "Sitapur District Court",
      "Unnao District Court",
    ],
    landmarks: ["Hazratganj HC campus", "Charbagh", "Gomti Nagar"],
    localFAQ: [
      {
        q: "Can a case filed in Prayagraj be heard at Lucknow Bench?",
        a: "No — jurisdiction is fixed by the district where the FIR was registered. Awadh region districts go to Lucknow; western UP goes to Prayagraj.",
        qHi: "क्या प्रयागराज में दायर केस लखनऊ बेंच में सुना जा सकता है?",
        aHi: "नहीं — क्षेत्राधिकार उस ज़िले से तय होता है जहाँ FIR दर्ज हुई। अवध क्षेत्र लखनऊ जाता है; पश्चिमी UP प्रयागराज।",
      },
    ],
  },

  "bail-lawyer-patna": {
    slug: "bail-lawyer-patna",
    city: "Patna",
    cityHindi: "पटना",
    highCourt: "Patna High Court",
    highCourtHindi: "पटना उच्च न्यायालय",
    established: "1916",
    seat: "Hardinge Road, Patna, Bihar",
    jurisdiction: "State of Bihar",
    metaTitle: "Anticipatory Bail Advocate in Patna — Patna High Court Verified",
    metaTitleHindi: "पटना में अग्रिम ज़मानत वकील — पटना उच्च न्यायालय से सत्यापित",
    metaDescription:
      "Verified anticipatory and regular bail advocates in Patna, ranked by real Patna High Court outcomes. Covers Civil Court Patna, Sessions Court, and all Bihar district benches.",
    metaDescriptionHindi:
      "पटना में सत्यापित अग्रिम और नियमित ज़मानत वकील — असली पटना उच्च न्यायालय के नतीजों पर आधारित।",
    heroH1: "An anticipatory bail advocate in Patna — verified, and fast.",
    heroH1Hindi: "पटना में एक अग्रिम ज़मानत वकील — सत्यापित, और तेज़।",
    heroSub:
      "The Patna High Court has jurisdiction over all of Bihar. Rihai connects you with advocates whose Patna-HC bail record is proven — from civil lines to district-level sessions courts.",
    heroSubHindi:
      "पटना उच्च न्यायालय का पूरे बिहार पर क्षेत्राधिकार है। Rihai आपको ऐसे वकीलों से जोड़ता है जिनका पटना HC ज़मानत रिकॉर्ड सिद्ध है।",
    subordinateCourts: [
      "Civil Court, Patna",
      "Patna Sessions Court",
      "CJM Patna",
      "Gaya District Court",
      "Muzaffarpur District Court",
      "Bhagalpur District Court",
    ],
    landmarks: ["Hardinge Road", "Gandhi Maidan", "Civil Lines"],
    localFAQ: [
      {
        q: "Anticipatory bail before an FIR is filed — is that possible in Patna?",
        a: "Yes. Section 482 BNSS (formerly 438 CrPC) allows anticipatory bail if there's reasonable apprehension of arrest. Patna High Court and Sessions Courts routinely entertain such applications.",
        qHi: "FIR दर्ज होने से पहले अग्रिम ज़मानत — क्या पटना में संभव है?",
        aHi: "हाँ। धारा 482 BNSS (पहले 438 CrPC) गिरफ़्तारी की उचित आशंका होने पर अग्रिम ज़मानत की अनुमति देती है।",
      },
    ],
  },

  "bail-lawyer-bangalore": {
    slug: "bail-lawyer-bangalore",
    city: "Bengaluru",
    cityHindi: "बेंगलुरु",
    highCourt: "Karnataka High Court",
    highCourtHindi: "कर्नाटक उच्च न्यायालय",
    established: "1884",
    seat: "Cubbon Park, Bengaluru",
    jurisdiction: "State of Karnataka",
    metaTitle: "Criminal & Bail Lawyer in Bengaluru — Karnataka High Court Verified",
    metaTitleHindi: "बेंगलुरु में आपराधिक व ज़मानत वकील — कर्नाटक उच्च न्यायालय से सत्यापित",
    metaDescription:
      "Verified bail and criminal lawyers in Bengaluru ranked by real Karnataka High Court outcomes. City Civil Court, Sessions Court, CCH benches — fast bail movement across Bengaluru.",
    metaDescriptionHindi:
      "बेंगलुरु में सत्यापित ज़मानत और आपराधिक वकील — असली कर्नाटक उच्च न्यायालय के नतीजों पर आधारित।",
    heroH1: "A verified criminal & bail lawyer in Bengaluru — proven, not promised.",
    heroH1Hindi: "बेंगलुरु में एक सत्यापित आपराधिक व ज़मानत वकील — सिद्ध, वादा नहीं।",
    heroSub:
      "The Karnataka High Court at Cubbon Park hears bail, criminal, and constitutional matters. We pair you with advocates whose HC record we can actually show you.",
    heroSubHindi:
      "कर्नाटक उच्च न्यायालय कब्बन पार्क में ज़मानत, आपराधिक और संवैधानिक मामले सुनता है।",
    subordinateCourts: [
      "City Civil & Sessions Court, Bengaluru",
      "Special CCH Benches",
      "Magistrate Courts, Mayo Hall",
      "Nrupathunga Road Court Complex",
    ],
    landmarks: ["Cubbon Park", "Mayo Hall", "Nrupathunga Road"],
    localFAQ: [
      {
        q: "How quickly can a bail application move at Karnataka HC?",
        a: "Urgent bail matters can be mentioned same-day. Regular hearings are usually listed within 3–7 working days. Sessions-level bail is often faster.",
        qHi: "कर्नाटक HC में ज़मानत आवेदन कितनी जल्दी बढ़ सकता है?",
        aHi: "तात्कालिक मामले उसी दिन उठाए जा सकते हैं। नियमित सुनवाई आमतौर पर 3–7 कार्य दिवसों में सूचीबद्ध होती है।",
      },
    ],
  },

  "bail-lawyer-kolkata": {
    slug: "bail-lawyer-kolkata",
    city: "Kolkata",
    cityHindi: "कोलकाता",
    highCourt: "Calcutta High Court",
    highCourtHindi: "कलकत्ता उच्च न्यायालय",
    established: "1862",
    seat: "Esplanade, Kolkata",
    jurisdiction: "West Bengal & Andaman & Nicobar Islands",
    metaTitle: "Bail Lawyer in Kolkata — Calcutta High Court Verified",
    metaTitleHindi: "कोलकाता में ज़मानत वकील — कलकत्ता उच्च न्यायालय से सत्यापित",
    metaDescription:
      "India's oldest High Court. Verified bail advocates in Kolkata ranked by real Calcutta HC outcomes. Alipore, Bankshall, Sealdah court benches covered.",
    metaDescriptionHindi:
      "भारत का सबसे पुराना उच्च न्यायालय। कोलकाता में सत्यापित ज़मानत वकील — असली कलकत्ता HC के नतीजों पर आधारित।",
    heroH1: "A verified bail lawyer at India's oldest High Court.",
    heroH1Hindi: "भारत के सबसे पुराने उच्च न्यायालय में एक सत्यापित ज़मानत वकील।",
    heroSub:
      "The Calcutta High Court (est. 1862) has jurisdiction over West Bengal and the A&N Islands. Rihai connects you with advocates whose recent bail outcomes here are documented.",
    heroSubHindi:
      "कलकत्ता उच्च न्यायालय (स्थापित 1862) का पश्चिम बंगाल और A&N द्वीप समूह पर क्षेत्राधिकार है।",
    subordinateCourts: [
      "Alipore Judges' Court",
      "Bankshall Court",
      "Sealdah Court",
      "Barasat District Court",
      "Howrah District Court",
    ],
    landmarks: ["Esplanade", "BBD Bagh", "Alipore"],
    localFAQ: [
      {
        q: "Is Calcutta HC also the appellate court for A&N Islands?",
        a: "Yes — the Calcutta High Court exercises appellate and writ jurisdiction over the Andaman & Nicobar Islands Union Territory. Matters can be moved from Port Blair to Calcutta HC.",
        qHi: "क्या कलकत्ता HC A&N द्वीप समूह के लिए भी अपीलीय अदालत है?",
        aHi: "हाँ — कलकत्ता उच्च न्यायालय अंडमान व निकोबार द्वीप समूह UT पर अपीलीय क्षेत्राधिकार रखता है।",
      },
    ],
  },

  "bail-lawyer-guwahati": {
    slug: "bail-lawyer-guwahati",
    city: "Guwahati",
    cityHindi: "गुवाहाटी",
    highCourt: "Gauhati High Court",
    highCourtHindi: "गुवाहाटी उच्च न्यायालय",
    established: "1948",
    seat: "Guwahati, Assam",
    jurisdiction: "Assam, Nagaland, Mizoram, Arunachal Pradesh",
    metaTitle: "Bail Lawyer in Guwahati — Gauhati High Court Verified",
    metaTitleHindi: "गुवाहाटी में ज़मानत वकील — गुवाहाटी उच्च न्यायालय से सत्यापित",
    metaDescription:
      "Verified bail advocates for the Gauhati High Court and North East. Serves Assam, Nagaland, Mizoram and Arunachal Pradesh — with local subordinate court linkages.",
    metaDescriptionHindi:
      "गुवाहाटी उच्च न्यायालय और पूर्वोत्तर के लिए सत्यापित ज़मानत वकील। असम, नागालैंड, मिज़ोरम, अरुणाचल के लिए।",
    heroH1: "A verified bail lawyer for the North East — from the Gauhati High Court.",
    heroH1Hindi: "पूर्वोत्तर के लिए एक सत्यापित ज़मानत वकील — गुवाहाटी उच्च न्यायालय से।",
    heroSub:
      "The Gauhati High Court has jurisdiction over Assam, Nagaland, Mizoram and Arunachal Pradesh via its principal seat and Aizawl, Kohima, Itanagar benches. Rihai connects you with advocates who actually work these benches.",
    heroSubHindi:
      "गुवाहाटी उच्च न्यायालय का असम, नागालैंड, मिज़ोरम, अरुणाचल पर मुख्य पीठ और आइज़ोल, कोहिमा, इटानगर बेंचों से क्षेत्राधिकार है।",
    subordinateCourts: [
      "Kamrup Sessions Court",
      "CJM Guwahati",
      "Aizawl Bench (Mizoram)",
      "Kohima Bench (Nagaland)",
      "Itanagar Bench (Arunachal Pradesh)",
    ],
    landmarks: ["Guwahati HC campus", "Fancy Bazar", "Uzan Bazar"],
    localFAQ: [
      {
        q: "Can a Mizoram case be heard at Guwahati?",
        a: "The Gauhati HC has permanent benches at Aizawl (Mizoram), Kohima (Nagaland) and Itanagar (Arunachal). Cases are typically heard at the bench of that state. Some matters transfer to the principal seat at Guwahati.",
        qHi: "क्या मिज़ोरम का केस गुवाहाटी में सुना जा सकता है?",
        aHi: "गुवाहाटी HC की स्थायी बेंच आइज़ोल, कोहिमा और इटानगर में हैं। मामले आमतौर पर उसी राज्य की बेंच में सुने जाते हैं।",
      },
    ],
  },
};

// --- Iteration 6 additions ---
CITIES["bail-lawyer-mumbai"] = {
  slug: "bail-lawyer-mumbai",
  city: "Mumbai",
  cityHindi: "मुंबई",
  highCourt: "Bombay High Court",
  highCourtHindi: "बॉम्बे उच्च न्यायालय",
  established: "1862",
  seat: "Fort, Mumbai",
  jurisdiction: "Maharashtra, Goa, Daman & Diu and Dadra & Nagar Haveli",
  metaTitle: "Bail Lawyer in Mumbai — Bombay High Court Verified",
  metaTitleHindi: "मुंबई में ज़मानत वकील — बॉम्बे उच्च न्यायालय से सत्यापित",
  metaDescription:
    "Verified bail lawyers in Mumbai ranked by real Bombay High Court outcomes. Sessions Court Fort, Esplanade, Andheri and Dindoshi courts covered. Anticipatory, regular and interim bail — moved fast.",
  metaDescriptionHindi:
    "मुंबई में सत्यापित ज़मानत वकील — असली बॉम्बे उच्च न्यायालय के नतीजों पर आधारित। फोर्ट सत्र न्यायालय, एस्प्लेनेड, अंधेरी और दिंदोशी कोर्ट।",
  heroH1: "A verified bail lawyer in Mumbai — before the night custody extends.",
  heroH1Hindi: "मुंबई में एक सत्यापित ज़मानत वकील — हिरासत बढ़ने से पहले।",
  heroSub:
    "The Bombay High Court at Fort hears bail matters for Mumbai and beyond. Rihai connects you with advocates whose recent bail outcomes across the Sessions Court, Esplanade and suburban magistrate courts we can actually show you.",
  heroSubHindi:
    "फोर्ट स्थित बॉम्बे उच्च न्यायालय मुंबई और आगे के ज़मानत मामले सुनता है। Rihai आपको ऐसे वकीलों से जोड़ता है जिनके हाल के नतीजे हम दिखा सकते हैं।",
  subordinateCourts: [
    "Sessions Court, Mumbai (Fort)",
    "Esplanade Metropolitan Magistrate Court",
    "Andheri Metropolitan Magistrate Court",
    "Borivali Metropolitan Magistrate Court",
    "Kurla Metropolitan Magistrate Court",
    "Dindoshi Sessions Court (Goregaon)",
  ],
  landmarks: ["Fort HC precinct", "Kala Ghoda", "CST"],
  localFAQ: [
    {
      q: "Which Mumbai court hears my bail first?",
      a: "Magistrate courts (Esplanade for south Mumbai, Andheri/Borivali/Kurla for the suburbs) hear bail first. If refused or the offence is serious, the Sessions Court at Fort or Dindoshi, then the Bombay High Court.",
      qHi: "मुंबई में मेरी ज़मानत पहले कौन सी कोर्ट सुनेगी?",
      aHi: "पहले मजिस्ट्रेट कोर्ट (दक्षिण मुंबई के लिए एस्प्लेनेड, उपनगरों के लिए अंधेरी/बोरीवली/कुर्ला)। इनकार या गंभीर आरोप पर फोर्ट या दिंदोशी सत्र न्यायालय, फिर बॉम्बे उच्च न्यायालय।",
    },
    {
      q: "How fast is anticipatory bail in Mumbai?",
      a: "Sessions Court anticipatory bail applications can be listed within 2–5 working days; interim protection is often argued the same day. High Court matters usually list within a week.",
      qHi: "मुंबई में अग्रिम ज़मानत कितनी जल्दी होती है?",
      aHi: "सत्र न्यायालय में अग्रिम ज़मानत 2–5 कार्य दिवसों में सूचीबद्ध हो सकती है; अंतरिम सुरक्षा अक्सर उसी दिन माँगी जाती है। उच्च न्यायालय में आमतौर पर एक सप्ताह।",
    },
  ],
};

CITIES["bail-lawyer-chennai"] = {
  slug: "bail-lawyer-chennai",
  city: "Chennai",
  cityHindi: "चेन्नई",
  highCourt: "Madras High Court",
  highCourtHindi: "मद्रास उच्च न्यायालय",
  established: "1862",
  seat: "George Town, Chennai",
  jurisdiction: "Tamil Nadu & Puducherry",
  metaTitle: "Bail Lawyer in Chennai — Madras High Court Verified",
  metaTitleHindi: "चेन्नई में ज़मानत वकील — मद्रास उच्च न्यायालय से सत्यापित",
  metaDescription:
    "Verified bail lawyers in Chennai ranked by real Madras High Court outcomes. City Sessions Court, Egmore and Saidapet magistrate courts covered — anticipatory and regular bail moved fast.",
  metaDescriptionHindi:
    "चेन्नई में सत्यापित ज़मानत वकील — असली मद्रास उच्च न्यायालय के नतीजों पर आधारित। सिटी सत्र न्यायालय, एग्मोर और सैदापेट कोर्ट।",
  heroH1: "A verified bail lawyer in Chennai — proven at the Madras High Court.",
  heroH1Hindi: "चेन्नई में एक सत्यापित ज़मानत वकील — मद्रास उच्च न्यायालय में सिद्ध।",
  heroSub:
    "The Madras High Court (est. 1862) covers Tamil Nadu and Puducherry, with a bench at Madurai. Rihai connects you with advocates whose recent Chennai bail outcomes are documented — not promised.",
  heroSubHindi:
    "मद्रास उच्च न्यायालय (स्थापित 1862) तमिलनाडु और पुडुचेरी को कवर करता है, मदुरै में बेंच के साथ। Rihai आपको ऐसे वकीलों से जोड़ता है जिनके हाल के चेन्नई नतीजे प्रमाणित हैं।",
  subordinateCourts: [
    "Madras City Civil & Sessions Court",
    "Egmore Magistrate Court",
    "Saidapet Court",
    "George Town Court",
    "Madurai Bench (southern TN districts)",
  ],
  landmarks: ["George Town HC campus", "Marina Beach", "Egmore"],
  localFAQ: [
    {
      q: "My case is in the Madurai region — do I still come to Chennai?",
      a: "No. The Madurai Bench of the Madras High Court handles southern Tamil Nadu districts. The principal seat at Chennai handles the rest of Tamil Nadu, including Puducherry.",
      qHi: "मेरा केस मदुरै क्षेत्र में है — क्या मुझे चेन्नई आना होगा?",
      aHi: "नहीं। मद्रास उच्च न्यायालय की मदुरै बेंच दक्षिणी तमिलनाडु के ज़िले संभालती है। चेन्नई मुख्य पीठ बाकी तमिलनाडु और पुडुचेरी संभालती है।",
    },
    {
      q: "How fast does bail move in Chennai?",
      a: "Magistrate-level bail can be heard the same day if moved early. Sessions Court matters list within 2–5 working days; Madras HC anticipatory bail usually within a week.",
      qHi: "चेन्नई में ज़मानत कितनी जल्दी होती है?",
      aHi: "मजिस्ट्रेट स्तर पर ज़मानत उसी दिन सुनी जा सकती है। सत्र न्यायालय में 2–5 कार्य दिवस; मद्रास HC में अग्रिम ज़मानत आमतौर पर एक सप्ताह में।",
    },
  ],
};

CITIES["bail-lawyer-hyderabad"] = {
  slug: "bail-lawyer-hyderabad",
  city: "Hyderabad",
  cityHindi: "हैदराबाद",
  highCourt: "Telangana High Court",
  highCourtHindi: "तेलंगाना उच्च न्यायालय",
  established: "2019",
  seat: "Hyderabad, Telangana",
  jurisdiction: "State of Telangana",
  metaTitle: "Bail Lawyer in Hyderabad — Telangana High Court Verified",
  metaTitleHindi: "हैदराबाद में ज़मानत वकील — तेलंगाना उच्च न्यायालय से सत्यापित",
  metaDescription:
    "Verified bail lawyers in Hyderabad ranked by real Telangana High Court outcomes. Nampally, Purani Haveli, Cyberabad and Ranga Reddy courts covered — anticipatory and regular bail.",
  metaDescriptionHindi:
    "हैदराबाद में सत्यापित ज़मानत वकील — असली तेलंगाना उच्च न्यायालय के नतीजों पर आधारित। नामपल्ली, पुरानी हवेली, साइबराबाद और रंगा रेड्डी कोर्ट।",
  heroH1: "A verified bail lawyer in Hyderabad — one call, no middlemen.",
  heroH1Hindi: "हैदराबाद में एक सत्यापित ज़मानत वकील — एक कॉल, कोई बिचौलिया नहीं।",
  heroSub:
    "The Telangana High Court has heard the state's bail matters since 2019. Rihai matches you with advocates whose recent outcomes across Nampally, Purani Haveli and Cyberabad courts we can actually show you.",
  heroSubHindi:
    "तेलंगाना उच्च न्यायालय 2019 से राज्य के ज़मानत मामले सुनता है। Rihai आपको ऐसे वकीलों से जोड़ता है जिनके नामपल्ली, पुरानी हवेली और साइबराबाद कोर्ट के हाल के नतीजे हम दिखा सकते हैं।",
  subordinateCourts: [
    "City Civil & Sessions Court, Nampally",
    "Purani Haveli Courts Complex",
    "Ranga Reddy District Court (LB Nagar)",
    "Cyberabad Magistrate Courts",
    "Secunderabad Cantonment Court",
  ],
  landmarks: ["HC complex, Naya Pul", "Charminar", "Nampally"],
  localFAQ: [
    {
      q: "Is bail in Hyderabad heard at the Telangana HC or the AP HC?",
      a: "Since 2019, Telangana has its own High Court at Hyderabad. The Andhra Pradesh High Court at Amaravati handles AP cases only — your Telangana case stays with the Telangana HC.",
      qHi: "हैदराबाद की ज़मानत तेलंगाना HC में सुनी जाती है या AP HC में?",
      aHi: "2019 से तेलंगाना का अपना उच्च न्यायालय हैदराबाद में है। अमरावती की AP HC केवल आंध्र प्रदेश के मामले सुनती है — आपका केस तेलंगाना HC में ही रहेगा।",
    },
    {
      q: "How quickly can anticipatory bail be listed in Hyderabad?",
      a: "At the City Sessions Court (Nampally / Purani Haveli), anticipatory bail can be listed in 2–5 working days, with interim protection argued early. High Court matters typically list within a week.",
      qHi: "हैदराबाद में अग्रिम ज़मानत कितनी जल्दी सूचीबद्ध होती है?",
      aHi: "सिटी सत्र न्यायालय (नामपल्ली / पुरानी हवेली) में अग्रिम ज़मानत 2–5 कार्य दिवसों में सूचीबद्ध हो सकती है। उच्च न्यायालय में आमतौर पर एक सप्ताह।",
    },
  ],
};

// --- Iteration 8 additions ---
CITIES["bail-lawyer-jaipur"] = {
  slug: "bail-lawyer-jaipur",
  city: "Jaipur",
  cityHindi: "जयपुर",
  highCourt: "Rajasthan High Court — Jaipur Bench",
  highCourtHindi: "राजस्थान उच्च न्यायालय — जयपुर बेंच",
  established: "1949",
  seat: "Jaipur Bench (principal seat: Jodhpur)",
  jurisdiction: "Jaipur division districts, Rajasthan",
  metaTitle: "Bail Lawyer in Jaipur — Rajasthan High Court Jaipur Bench Verified",
  metaTitleHindi: "जयपुर में ज़मानत वकील — राजस्थान उच्च न्यायालय जयपुर बेंच से सत्यापित",
  metaDescription:
    "Verified bail lawyers in Jaipur ranked by real Rajasthan High Court (Jaipur Bench) outcomes. District & Sessions Court JLN Marg, CJM Jaipur covered — anticipatory and regular bail moved fast.",
  metaDescriptionHindi:
    "जयपुर में सत्यापित ज़मानत वकील — असली राजस्थान उच्च न्यायालय (जयपुर बेंच) के नतीजों पर आधारित। JLN मार्ग ज़िला व सत्र न्यायालय, CJM जयपुर।",
  heroH1: "A verified bail lawyer in Jaipur — the Bench city's own advocates.",
  heroH1Hindi: "जयपुर में एक सत्यापित ज़मानत वकील — बेंच शहर के अपने अधिवक्ता।",
  heroSub:
    "Jaipur hosts a full bench of the Rajasthan High Court. Rihai connects you with advocates whose recent bail outcomes at the Jaipur Bench and the JLN Marg sessions court we can actually show you.",
  heroSubHindi:
    "जयपुर में राजस्थान उच्च न्यायालय की पूर्ण बेंच है। Rihai आपको ऐसे अधिवक्ताओं से जोड़ता है जिनके जयपुर बेंच और JLN मार्ग सत्र न्यायालय के हाल के नतीजे हम दिखा सकते हैं।",
  subordinateCourts: [
    "District & Sessions Court, Jaipur (JLN Marg)",
    "Chief Judicial Magistrate, Jaipur",
    "Jaipur Metropolitan Magistrate Courts",
    "Family Court, Jaipur",
    "Rajasthan HC — Jaipur Bench",
  ],
  landmarks: ["JLN Marg", "Statue Circle", "C-Scheme"],
  localFAQ: [
    {
      q: "Does my bail go to Jaipur or Jodhpur?",
      a: "The Rajasthan High Court's principal seat is Jodhpur, but the Jaipur Bench hears matters from Jaipur-division districts. Most Jaipur cases are filed and heard right here — no travel to Jodhpur needed.",
      qHi: "मेरी ज़मानत जयपुर जाएगी या जोधपुर?",
      aHi: "राजस्थान उच्च न्यायालय की मुख्य पीठ जोधपुर है, लेकिन जयपुर बेंच जयपुर संभाग के मामले सुनती है। ज़्यादातर जयपुर के मामले यहीं दायर और सुने जाते हैं।",
    },
    {
      q: "How fast is bail in Jaipur?",
      a: "Magistrate-level bail can be heard the same day. Sessions Court matters at JLN Marg typically list within 2–5 working days; Jaipur Bench anticipatory bail usually within a week.",
      qHi: "जयपुर में ज़मानत कितनी जल्दी होती है?",
      aHi: "मजिस्ट्रेट स्तर पर उसी दिन सुनवाई संभव है। JLN मार्ग सत्र न्यायालय में 2–5 कार्य दिवस; जयपुर बेंच में अग्रिम ज़मानत आमतौर पर एक सप्ताह में।",
    },
  ],
};

CITIES["bail-lawyer-ahmedabad"] = {
  slug: "bail-lawyer-ahmedabad",
  city: "Ahmedabad",
  cityHindi: "अहमदाबाद",
  highCourt: "Gujarat High Court",
  highCourtHindi: "गुजरात उच्च न्यायालय",
  established: "1960",
  seat: "Sola, Ahmedabad",
  jurisdiction: "State of Gujarat",
  metaTitle: "Bail Lawyer in Ahmedabad — Gujarat High Court Verified",
  metaTitleHindi: "अहमदाबाद में ज़मानत वकील — गुजरात उच्च न्यायालय से सत्यापित",
  metaDescription:
    "Verified bail lawyers in Ahmedabad ranked by real Gujarat High Court outcomes. City Civil & Sessions Court Bhadra, Mirzapur courts covered — anticipatory and regular bail moved quickly.",
  metaDescriptionHindi:
    "अहमदाबाद में सत्यापित ज़मानत वकील — असली गुजरात उच्च न्यायालय के नतीजों पर आधारित। भाद्रा सिटी सिविल व सत्र न्यायालय, मिर्ज़ापुर कोर्ट।",
  heroH1: "A verified bail lawyer in Ahmedabad — ranked by Gujarat HC outcomes.",
  heroH1Hindi: "अहमदाबाद में एक सत्यापित ज़मानत वकील — गुजरात HC के नतीजों पर आधारित।",
  heroSub:
    "The Gujarat High Court at Sola is right here in the city. Rihai connects you with advocates whose recent bail record across Bhadra sessions court and the High Court we can document for you.",
  heroSubHindi:
    "सोला स्थित गुजरात उच्च न्यायालय शहर में ही है। Rihai आपको ऐसे अधिवक्ताओं से जोड़ता है जिनका भाद्रा सत्र न्यायालय और हाई कोर्ट का हाल का रिकॉर्ड हम प्रमाणित कर सकते हैं।",
  subordinateCourts: [
    "City Civil & Sessions Court, Bhadra",
    "Mirzapur Court Complex",
    "Chief Judicial Magistrate, Ahmedabad",
    "Family Court, Ahmedabad",
    "Gujarat High Court, Sola",
  ],
  landmarks: ["Sola HC campus", "Ashram Road", "Bhadra"],
  localFAQ: [
    {
      q: "Where is bail heard first in Ahmedabad?",
      a: "Magistrate courts first, then the City Sessions Court at Bhadra, and finally the Gujarat High Court at Sola. Anticipatory bail can start directly at Sessions or the High Court.",
      qHi: "अहमदाबाद में ज़मानत पहले कहाँ सुनी जाती है?",
      aHi: "पहले मजिस्ट्रेट कोर्ट, फिर भाद्रा सिटी सत्र न्यायालय, और अंत में सोला गुजरात उच्च न्यायालय। अग्रिम ज़मानत सीधे सत्र या हाई कोर्ट से शुरू हो सकती है।",
    },
    {
      q: "How quickly can anticipatory bail move in Ahmedabad?",
      a: "Sessions-level anticipatory bail typically lists in 2–5 working days with interim protection argued early. Gujarat HC matters usually list within a week.",
      qHi: "अहमदाबाद में अग्रिम ज़मानत कितनी जल्दी होती है?",
      aHi: "सत्र स्तर पर अग्रिम ज़मानत आमतौर पर 2–5 कार्य दिवसों में सूचीबद्ध होती है। गुजरात HC में आमतौर पर एक सप्ताह के भीतर।",
    },
  ],
};

CITIES["bail-lawyer-bhopal"] = {
  slug: "bail-lawyer-bhopal",
  city: "Bhopal",
  cityHindi: "भोपाल",
  highCourt: "Madhya Pradesh High Court (Jabalpur)",
  highCourtHindi: "मध्य प्रदेश उच्च न्यायालय (जबलपुर)",
  established: "1956",
  seat: "Principal seat: Jabalpur (benches: Indore, Gwalior)",
  jurisdiction: "State of Madhya Pradesh",
  metaTitle: "Bail Lawyer in Bhopal — MP High Court Verified Advocates",
  metaTitleHindi: "भोपाल में ज़मानत वकील — MP उच्च न्यायालय सत्यापित अधिवक्ता",
  metaDescription:
    "Verified bail lawyers in Bhopal for District & Sessions Court Arera Hills, with MP High Court (Jabalpur) escalation handled. Anticipatory and regular bail — transparent, no middlemen.",
  metaDescriptionHindi:
    "भोपाल में सत्यापित ज़मानत वकील — आरेरा हिल्स ज़िला व सत्र न्यायालय, और MP उच्च न्यायालय (जबलपुर) तक पूरी सेवा। बिना बिचौलियों के।",
  heroH1: "A verified bail lawyer in Bhopal — honest about how MP courts work.",
  heroH1Hindi: "भोपाल में एक सत्यापित ज़मानत वकील — MP अदालतों की सच्चाई के साथ।",
  heroSub:
    "Bhopal bail matters start at the Arera Hills sessions court; High Court escalation goes to Jabalpur. Rihai works with advocates who handle both ends — and whose outcomes we can show you.",
  heroSubHindi:
    "भोपाल के ज़मानत मामले आरेरा हिल्स सत्र न्यायालय से शुरू होते हैं; हाई कोर्ट चरण जबलपुर जाता है। Rihai ऐसे अधिवक्ताओं के साथ काम करता है जो दोनों स्तर संभालते हैं।",
  subordinateCourts: [
    "District & Sessions Court, Bhopal (Arera Hills)",
    "Chief Judicial Magistrate, Bhopal",
    "Family Court, Bhopal",
    "MP High Court — Principal Seat, Jabalpur",
    "MP High Court — Indore / Gwalior Benches",
  ],
  landmarks: ["Arera Hills courts", "MP Nagar", "New Market"],
  localFAQ: [
    {
      q: "Is the MP High Court in Bhopal?",
      a: "No — the Madhya Pradesh High Court's principal seat is Jabalpur, with benches at Indore and Gwalior. Bhopal cases begin at the local magistrate/sessions courts; the HC stage is handled at Jabalpur, which our advocates cover.",
      qHi: "क्या MP हाई कोर्ट भोपाल में है?",
      aHi: "नहीं — मध्य प्रदेश उच्च न्यायालय की मुख्य पीठ जबलपुर है, बेंच इंदौर और ग्वालियर में। भोपाल के मामले स्थानीय मजिस्ट्रेट/सत्र न्यायालय से शुरू होते हैं; HC चरण जबलपुर में होता है, जिसे हमारे अधिवक्ता संभालते हैं।",
    },
    {
      q: "How fast is bail in Bhopal?",
      a: "Magistrate-level bail can be same-day. Sessions Court at Arera Hills typically lists in 2–5 working days. Jabalpur HC matters usually take one to two weeks.",
      qHi: "भोपाल में ज़मानत कितनी जल्दी होती है?",
      aHi: "मजिस्ट्रेट स्तर पर उसी दिन संभव है। आरेरा हिल्स सत्र न्यायालय में 2–5 कार्य दिवस। जबलपुर HC में आमतौर पर एक-दो सप्ताह।",
    },
  ],
};

CITIES["bail-lawyer-chandigarh"] = {
  slug: "bail-lawyer-chandigarh",
  city: "Chandigarh",
  cityHindi: "चंडीगढ़",
  highCourt: "Punjab & Haryana High Court",
  highCourtHindi: "पंजाब और हरियाणा उच्च न्यायालय",
  established: "1947",
  seat: "Sector 1, Chandigarh",
  jurisdiction: "Punjab, Haryana & UT Chandigarh",
  metaTitle: "Bail Lawyer in Chandigarh — Punjab & Haryana High Court Verified",
  metaTitleHindi: "चंडीगढ़ में ज़मानत वकील — पंजाब और हरियाणा उच्च न्यायालय से सत्यापित",
  metaDescription:
    "Verified bail lawyers in Chandigarh ranked by real Punjab & Haryana High Court outcomes. Sector 43 District Courts, CJM Chandigarh, Punjab and Haryana districts covered.",
  metaDescriptionHindi:
    "चंडीगढ़ में सत्यापित ज़मानत वकील — असली पंजाब और हरियाणा उच्च न्यायालय के नतीजों पर आधारित। सेक्टर 43 ज़िला अदालतें, CJM चंडीगढ़।",
  heroH1: "A verified bail lawyer in Chandigarh — one court, three jurisdictions.",
  heroH1Hindi: "चंडीगढ़ में एक सत्यापित ज़मानत वकील — एक अदालत, तीन क्षेत्राधिकार।",
  heroSub:
    "The Punjab & Haryana High Court at Sector 1 covers Punjab, Haryana and the UT itself. Rihai connects you with advocates whose recent bail outcomes here — and at the Sector 43 district courts — are documented.",
  heroSubHindi:
    "सेक्टर 1 स्थित पंजाब और हरियाणा उच्च न्यायालय पंजाब, हरियाणा और UT को कवर करता है। Rihai आपको ऐसे अधिवक्ताओं से जोड़ता है जिनके यहाँ और सेक्टर 43 ज़िला अदालतों के हाल के नतीजे प्रमाणित हैं।",
  subordinateCourts: [
    "District & Sessions Court, Chandigarh (Sector 43)",
    "Chief Judicial Magistrate, Chandigarh",
    "Punjab district courts (Ludhiana, Amritsar, Patiala)",
    "Haryana district courts (Gurugram, Faridabad, Karnal)",
    "Punjab & Haryana High Court, Sector 1",
  ],
  landmarks: ["Capitol Complex", "Sector 17", "Sector 43 courts"],
  localFAQ: [
    {
      q: "My FIR is in Mohali — is that Chandigarh's court?",
      a: "Mohali (SAS Nagar) falls under Punjab's district courts, with the High Court stage at Chandigarh. UT Chandigarh FIRs go to the Sector 43 district courts. Either way, the HC is the same.",
      qHi: "मेरी FIR मोहाली में है — क्या वह चंडीगढ़ की अदालत में जाएगी?",
      aHi: "मोहाली (SAS नगर) पंजाब की ज़िला अदालतों में आता है, हाई कोर्ट चरण चंडीगढ़ में। UT चंडीगढ़ की FIR सेक्टर 43 अदालतों में जाती है। दोनों में HC एक ही है।",
    },
    {
      q: "How fast is anticipatory bail at the Punjab & Haryana HC?",
      a: "Urgent matters can be mentioned quickly; typical listing is 3–7 working days. Sessions-level anticipatory bail in Chandigarh is often faster — 2–4 working days.",
      qHi: "पंजाब और हरियाणा HC में अग्रिम ज़मानत कितनी जल्दी होती है?",
      aHi: "तात्कालिक मामले जल्दी उठाए जा सकते हैं; सामान्य सूचीकरण 3–7 कार्य दिवस। चंडीगढ़ में सत्र स्तर पर अक्सर 2–4 कार्य दिवस।",
    },
  ],
};

export const CITY_SLUGS = Object.keys(CITIES);
export const getCityBySlug = (slug) => CITIES[slug] || null;
